import React from 'react'
import {
  getFormattedAddress,
  getFormattedDateAndTime,
  TestSessionFormValues,
  User_user_Address,
} from '@modmd/data'
import { useHistory } from 'react-router-dom'
import { FormikProps } from 'formik'
import { Text } from 'components/Typography'
import Button from 'components/Button'
import { COLOR } from 'theme'
import { PERSONAL_ROUTES } from 'client-portal/constants/routes'
import { Box } from 'components/Layout'

interface Props {
  labAddress?: Partial<User_user_Address> | null | undefined
  isWalkIn?: boolean
  testSessionData: FormikProps<TestSessionFormValues>
}

export const ThankYou: React.VFC<Props> = ({ labAddress, isWalkIn, testSessionData }) => {
  const history = useHistory()
  const { Address, date } = testSessionData.values
  const formattedAddress = getFormattedAddress(Address)
  const formattedLabAddress = getFormattedAddress(labAddress)
  const dateAndTime = date
    ? getFormattedDateAndTime(date, true)?.split(' ').join(' at ')
    : undefined

  return (
    <Box textAlign="center">
      <Box>
        <Text color={COLOR.brand}>
          You have requested a {isWalkIn && 'walk-in'} test session on {dateAndTime} at{' '}
          {isWalkIn ? formattedLabAddress : formattedAddress}. Our scheduling team will contact you
          to confirm the appointment or if we need to change any of the details.
        </Text>
      </Box>

      <Button
        mt="2rem"
        onClick={() => {
          history.push(`/${PERSONAL_ROUTES.SESSIONS}`)
        }}
      >
        Back to Test Sessions
      </Button>
    </Box>
  )
}
